(() => {
  function iniciarCarrusel(root) {
    if (root.dataset.tbCareersReady === 'true') return;
    const slides = [...root.querySelectorAll('[data-tb-careers-slide]')];
    if (slides.length < 2) return;
    root.dataset.tbCareersReady = 'true';
    const track = root.querySelector('[data-tb-careers-slides]');
    const controls = root.querySelector('[data-tb-careers-controls]');
    const dots = [...root.querySelectorAll('[data-tb-careers-dot]')];
    const previous = root.querySelector('[data-tb-careers-previous]');
    const next = root.querySelector('[data-tb-careers-next]');
    const pause = root.querySelector('[data-tb-careers-pause]');
    const passiveBanner = !controls;
    const pauseText = pause?.querySelector('[data-tb-careers-pause-text]');
    const pauseIcon = pause?.querySelector('[data-tb-careers-pause-icon]');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const events = new AbortController();
    let current = 0;
    let requestedIndex = 0;
    let requestId = 0;
    let loading = false;
    let automaticRequest = false;
    const readySlides = new Set([slides[0]]);
    const imageLoads = new Map();
    let userPaused = reduced.matches || (!passiveBanner && root.contains(document.activeElement));
    let focusPaused = passiveBanner && root.contains(document.activeElement);
    let hovering = false;
    let timer = null;
    function programar() {
      clearTimeout(timer);
      const rotating = !loading && !userPaused && !focusPaused && !hovering && !document.hidden && !reduced.matches;
      track.setAttribute('aria-live', rotating ? 'off' : 'polite');
      if (pause) {
        const label = userPaused ? pause.dataset.resumeLabel : pause.dataset.pauseLabel;
        pause.setAttribute('aria-label', label);
        pauseText.textContent = label;
        pauseIcon.textContent = userPaused ? '▶' : 'Ⅱ';
        pause.hidden = reduced.matches;
      }
      if (rotating) timer = setTimeout(() => mostrar(current + 1, false, true), passiveBanner ? 5000 : 7000);
    }
    function cargarImagen(slide) {
      if (imageLoads.has(slide)) return imageLoads.get(slide);
      for (const source of slide.querySelectorAll('source[data-srcset]')) {
        source.srcset = source.dataset.srcset;
        delete source.dataset.srcset;
      }
      for (const image of slide.querySelectorAll('img[data-src]')) {
        image.loading = 'eager';
        image.src = image.dataset.src;
        delete image.dataset.src;
      }
      const image = slide.querySelector('img');
      const decoded = Promise.resolve().then(() => image.decode()).then(() => { readySlides.add(slide); });
      imageLoads.set(slide, decoded);
      return decoded;
    }
    function aplicar(index, transferFocus) {
      const restoreFocus = transferFocus && slides.some((slide) => slide.contains(document.activeElement));
      current = index;
      slides.forEach((slide, i) => {
        slide.hidden = i !== current;
        slide.querySelector('a').tabIndex = i === current ? 0 : -1;
      });
      dots.forEach((dot, i) => {
        if (i === current) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (restoreFocus) slides[current].querySelector('a').focus({ preventScroll:true });
      programar();
    }
    function mostrar(index, transferFocus = false, automatic = false) {
      requestedIndex = (index + slides.length) % slides.length;
      const selectedIndex = requestedIndex;
      const selectedSlide = slides[selectedIndex];
      const id = ++requestId;
      automaticRequest = automatic;
      if (readySlides.has(selectedSlide)) {
        loading = false;
        aplicar(selectedIndex, transferFocus);
        return;
      }
      loading = true;
      programar();
      cargarImagen(selectedSlide).then(() => {
        if (id !== requestId || events.signal.aborted) return;
        loading = false;
        aplicar(selectedIndex, transferFocus);
      }).catch(() => {
        imageLoads.delete(selectedSlide);
        if (id !== requestId || events.signal.aborted) return;
        loading = false;
        requestedIndex = current;
        programar();
      });
    }
    function cancelarAutomatico() {
      if (!loading || !automaticRequest) return;
      requestId++;
      loading = false;
      requestedIndex = current;
      automaticRequest = false;
    }
    function escuchar(target, event, fn) { target.addEventListener(event, fn, { signal:events.signal }); }
    if (previous) escuchar(previous, 'click', () => mostrar(requestedIndex - 1));
    if (next) escuchar(next, 'click', () => mostrar(requestedIndex + 1));
    dots.forEach((dot, i) => escuchar(dot, 'click', () => mostrar(i)));
    if (pause) escuchar(pause, 'click', () => { userPaused = !userPaused; if (userPaused) cancelarAutomatico(); programar(); });
    if (!passiveBanner) {
      escuchar(root, 'mouseenter', () => { hovering = true; cancelarAutomatico(); programar(); });
      escuchar(root, 'mouseleave', () => { hovering = false; programar(); });
    }
    escuchar(root, 'focusin', () => { if (passiveBanner) focusPaused = true; else userPaused = true; cancelarAutomatico(); programar(); });
    if (passiveBanner) escuchar(root, 'focusout', (event) => { if (root.contains(event.relatedTarget)) return; focusPaused = false; programar(); });
    escuchar(root, 'keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      const focusOnSlide = slides.some((slide) => slide.contains(document.activeElement));
      mostrar(requestedIndex + (event.key === 'ArrowLeft' ? -1 : 1), focusOnSlide);
    });
    escuchar(document, 'visibilitychange', () => { if (document.hidden) cancelarAutomatico(); programar(); });
    escuchar(reduced, 'change', () => { if (reduced.matches) { userPaused = true; cancelarAutomatico(); } programar(); });
    escuchar(document, 'shopify:section:unload', (event) => {
      if (!event.target.contains(root)) return;
      clearTimeout(timer);
      events.abort();
      delete root.dataset.tbCareersReady;
    });
    if (controls) controls.hidden = false;
    mostrar(0);
  }
  function iniciar(scope = document) { scope.querySelectorAll('[data-tb-careers-carousel]').forEach(iniciarCarrusel); }
  iniciar();
  document.addEventListener('shopify:section:load', (event) => iniciar(event.target));
})();
